// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"48815e2c","239":"36b4977a","429":"a91d44ea","455":"e83b2cdf","529":"1bc0fd72","556":"bb6c1f9f","661":"6cda7dc3","731":"926d73c6"}[chunkId] + ".chunk.js";
};